import { Stack } from "@mui/material";
import { SenecButton, SenecButtonProps } from "src/components/button/senec-button/SenecButton";
import { SenecButtonSize } from "src/components/button/ButtonUtils";
import { useScreenSize } from "src/hooks/useScreenSize";

export type DialogButtonsButtonProps = Omit<SenecButtonProps, "level" | "size"> & { "data-testid"?: string };

export interface DialogButtonsProps {
    primaryButton: DialogButtonsButtonProps;
    secondaryButton?: DialogButtonsButtonProps;
    size?: SenecButtonSize;
}

export const SenecDialogButtons = ({ primaryButton, secondaryButton, size }: DialogButtonsProps) => {
    const { isMobile } = useScreenSize();

    return isMobile ? (
        <Stack direction={"column"} gap="1rem">
            <SenecButton
                data-testid={primaryButton["data-testid"] ?? "primary-button"}
                size={size}
                {...primaryButton}
                sx={{ width: "100%" }}
            >
                {primaryButton.title}
            </SenecButton>
            {secondaryButton && (
                <SenecButton
                    data-testid={secondaryButton["data-testid"] ?? "secondary-button"}
                    level="secondary"
                    size={size}
                    {...secondaryButton}
                    sx={{ width: "100%" }}
                >
                    {secondaryButton.title}
                </SenecButton>
            )}
        </Stack>
    ) : (
        <Stack direction={"row"} gap="1rem" justifyContent="flex-end">
            {secondaryButton && (
                <SenecButton data-testid="secondary-button" level="secondary" size={size} {...secondaryButton}>
                    {secondaryButton.title}
                </SenecButton>
            )}
            <SenecButton data-testid="primary-button" size={size} {...primaryButton}>
                {primaryButton.title}
            </SenecButton>
        </Stack>
    );
};
